import { z } from 'zod'
import * as m from '~/paraglide/messages'
import { getValidCountryNames } from '~/shared/lib/countries'

export const locationFormSchema = z.object({
  name: z.string().nullable().optional(),
  street: z.string().min(1, m.streetRequired()),
  city: z.string().min(1, m.cityRequired()),
  country: z
    .string()
    .min(1, m.countryRequired())
    .refine((val) => getValidCountryNames().includes(val), {
      message: m.pleaseSelectAValidCountry(),
    }),
  coordinates: z
    .object({
      lat: z.number(),
      lng: z.number(),
    })
    .optional(),
})

export const tagsResponseSchema = z.object({
  category: z.object({
    id: z.string(),
    name: z.string(),
  }),
  subCategories: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  subSubCategories: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  amenities: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
})

export const tagsInputSchema = z.object({
  mainCategoryId: z.string().min(1, m.categoryRequired()),
  subCategoryTags: z
    .array(z.string())
    .min(1, m.pleaseSelectAtLeastOneSubcategory())
    .max(3, m.maximum3SubcategoriesAllowed()),
  subSubCategoryTags: z.array(z.string()).default([]),
  amenityIds: z.array(z.string()).default([]),
})
